import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/novedad_participante";
const url = (path = "") => `${baseUrl}${endpoint}${path}`;

// ─── Estado / consulta ─────────────────────────────────────────────────────

/**
 * Devuelve un mapa { documento: novedad_id } solo para los documentos que
 * tienen una novedad ACTIVA. Se usa para pintar el icono rojo/verde en la
 * tabla de /reporteRIT sin hacer una petición por fila.
 */
export const obtenerEstadoBulk = async (documentos = []) => {
  const unicos = Array.from(new Set(documentos.filter(Boolean)));
  if (!unicos.length) return {};
  const response = await axios.get(url("/estado-bulk"), {
    params: { documentos: unicos.join(",") },
  });
  return response.data;
};

/** Novedad activa (con soportes) + histórico de una cédula. */
export const obtenerNovedadPorDocumento = async (documento) => {
  const response = await axios.get(url(`/documento/${documento}`));
  return response.data;
};

/**
 * Precarga de datos para "Nueva novedad" desde el módulo standalone: busca
 * primero en el Reporte RIT y, si no aparece ahí, en el registro general de
 * participantes del sistema. Devuelve { encontrado: false } si no está en
 * ninguno (el formulario queda para diligenciar a mano).
 */
export const buscarParticipantePorDocumento = async (documento) => {
  const response = await axios.get(url(`/buscar-participante/${documento}`));
  return response.data;
};

/** Listado completo con filtros y paginación (módulo standalone Novedades). */
export const listarNovedades = async (filtros = {}) => {
  const response = await axios.get(url("/"), { params: filtros });
  return response.data;
};

/** Detalle de una novedad puntual (con soportes). */
export const obtenerNovedad = async (id) => {
  const response = await axios.get(url(`/${id}`));
  return response.data;
};

// ─── CRUD novedad ───────────────────────────────────────────────────────────

/** formData debe incluir municipio, documento_identificacion, nombre_completo,
 * municipio_id, codigo_dane_municipio, tipo_novedad, descripcion, fecha_novedad
 * y opcionalmente soportes[] — en ese orden de campos antes de los archivos. */
export const crearNovedad = async (formData) => {
  const response = await axios.post(url("/"), formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const actualizarNovedad = async (id, data) => {
  const response = await axios.put(url(`/${id}`), data);
  return response.data;
};

export const cambiarEstadoNovedad = async (id, estado) => {
  const response = await axios.patch(url(`/${id}/estado`), { estado });
  return response.data;
};

export const eliminarNovedad = async (id) => {
  const response = await axios.delete(url(`/${id}`));
  return response.data;
};

// ─── Soportes ────────────────────────────────────────────────────────────────

export const agregarSoporte = async (novedadId, formData) => {
  const response = await axios.post(url(`/${novedadId}/soporte`), formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const reemplazarSoporte = async (soporteId, formData) => {
  const response = await axios.put(url(`/soporte/${soporteId}`), formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const eliminarSoporte = async (soporteId) => {
  const response = await axios.delete(url(`/soporte/${soporteId}`));
  return response.data;
};

/** URL directa para <a>/<img>/descarga — modo "ver" (inline) o "descargar" (attachment). */
export const urlDescargaSoporte = (soporteId, modo = "descargar") =>
  url(`/soporte/${soporteId}/archivo?modo=${modo}`);

// ─── Auditoría ───────────────────────────────────────────────────────────────

export const listarAuditoriaNovedad = async (id) => {
  const response = await axios.get(url(`/${id}/auditoria`));
  return response.data;
};
